<template>
  <section class="page-block welcome-block" id="welcome-block">
    <div class="wide">

      <ImgSlider />

      <div class="mid">
        <div class="bot">
          <div class="tagline">
            <div class="yrow"><span class=""><span>&mdash;&nbsp;{{ $t('WelcomeScreen.WhatYouNeed') }}</span></span></div>
            <div class="wrow"><span class="">{{ $t('WelcomeScreen.WhatTo') }}</span></div>
            <div class="wrow"><span class="">{{ $t('WelcomeScreen.WhatBe') }}</span></div>
            <div class="wrow"><span class="">{{ $t('WelcomeScreen.WhatMan') }}</span></div>
          </div>
          <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
          <!-- <a href="https://bookon.ua/lite/kJo8Lctgp3sObNfqxGnx" target="_blank" class="order-button"> -->
            <span class="action">{{ $t('Buttons.MainButton') }}</span>
            <!-- <span class="service">Appointer</span> -->
          </a>
          <div class="contacts">
            <address>
              <p class="">{{ $t('Address.StreetA') }}</p>
              <p class="location">{{ $t('Address.StreetB') }}</p>
              <p class="phone">{{ $t('Address.Phone1') }}</p>
              <p class="phone">{{ $t('Address.Phone2') }}</p>
            </address>
            <div class="social-media">
              <a class="" href="https://www.facebook.com/Ballsbarbershop/" target="_blank">
                <span>{{ $t('Socials.Facebook') }}</span>
                <svg version="1.1" id="facebook-layer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
                  <path fill="#FFFFFF" id="facebook-shape" class="st0" d="M21.1,36H5.8c-1,0-1.8-0.8-1.8-1.8V5.8C4,4.8,4.8,4,5.8,4h28.5c1,0,1.8,0.8,1.8,1.8v28.5
                    c0,1-0.8,1.8-1.8,1.8h-8.2V23.6h4.2l0.6-4.8h-4.8v-3.1c0-1.4,0.4-2.4,2.4-2.4l2.6,0V9c-0.4-0.1-2-0.2-3.7-0.2
                    c-3.7,0-6.2,2.3-6.2,6.4v3.6h-4.2v4.8h4.2V36L21.1,36L21.1,36z"/>
                </svg>
              </a>
              <a class="" href="https://www.instagram.com/ballsbarbershopkyiv/" target="_blank">
                <span>{{ $t('Socials.Instagram') }}</span>
                <svg version="1.1" id="instagram-layer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
                  <path fill="#FFFFFF" id="instagram-shape" class="st0" d="M13.4,4.1C15.1,4,15.7,4,20,4s4.9,0,6.6,0.1c1.7,0.1,2.9,0.3,3.9,0.7
                    c1.1,0.4,1.9,1,2.8,1.8c0.9,0.9,1.4,1.8,1.8,2.8c0.4,1,0.7,2.2,0.7,3.9C36,15.1,36,15.7,36,20c0,4.3,0,4.9-0.1,6.6
                    c-0.1,1.7-0.3,2.9-0.7,3.9c-0.4,1.1-1,1.9-1.8,2.8c-0.9,0.9-1.8,1.4-2.8,1.8c-1,0.4-2.2,0.7-3.9,0.7C24.9,36,24.3,36,20,36
                    s-4.9,0-6.6-0.1c-1.7-0.1-2.9-0.3-3.9-0.7c-1.1-0.4-1.9-1-2.8-1.8c-0.9-0.9-1.4-1.8-1.8-2.8c-0.4-1-0.7-2.2-0.7-3.9
                    C4,24.9,4,24.3,4,20c0-4.3,0-4.9,0.1-6.6c0.1-1.7,0.3-2.9,0.7-3.9c0.4-1.1,1-1.9,1.8-2.8c0.9-0.9,1.8-1.4,2.8-1.8
                    C10.5,4.4,11.7,4.2,13.4,4.1z M20,11.8c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2C28.2,15.5,24.5,11.8,20,11.8z
                      M20,25.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3C25.3,22.9,22.9,25.3,20,25.3z M30.5,11.5
                    c0-1.1-0.9-1.9-1.9-1.9c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9C29.6,13.4,30.5,12.5,30.5,11.5z"/>
                </svg>
              </a>
              <a class="" href="https://www.youtube.com/channel/UCTzjcy93Zj36coMlCFWGcKQ" target="_blank">
                <span>{{ $t('Socials.Youtube') }}</span>
                <svg version="1.1" id="youtube-layer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
                  <path fill="#FFFFFF" id="youtube-shape" class="st0" d="M9.1,5.2L11,5c6-0.7,12-0.7,18,0l1.9,0.2c4.1,0.5,7.1,3.9,7.1,8v13.7c0,4.1-3.1,7.5-7.1,7.9
                    L29.2,35c-5.9,0.7-11.8,0.7-17.7,0l-2.4-0.3c-4.1-0.4-7.1-3.9-7.1-8V13.2C2,9.1,5.1,5.7,9.1,5.2z M14,12v16l16-7L14,12z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="arrows-scroll arrow-1" src="@/i/welcome/arrow-1.svg" alt="scroll">
    <img class="arrows-scroll arrow-2" src="@/i/welcome/arrow-2.svg" alt="scroll">
    <img class="arrows-scroll arrow-3" src="@/i/welcome/arrow-3.svg" alt="scroll">
  </section>


  
</template>

<script>

import ImgSlider from '@/components/home/parts/ImgSlider'

export default {
  name: 'welcome-screen',
  components: {
    ImgSlider
  },
  props: {
  }
}
</script>
